/**
 * A compact risk note for the How It Works page.
 *
 * The page explains how to run GoldWarden live, so it should state plainly that
 * trading gold carries real risk — matching the tone used on the Performance
 * and home pages rather than implying any outcome is guaranteed.
 *
 * Note: no link to /performance lives here. The Setup panel directly above
 * already carries the "See live performance" button, so a second link to the
 * same page would just repeat the action twice in a row.
 */
export default function RiskNote() {
  return (
    <section className="py-10 md:py-12 bg-background-50 border-t border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-shell mx-auto">
          <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
            <span className="shrink-0 w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
              <i className="ri-error-warning-line text-xl" aria-hidden="true"></i>
            </span>
            <p className="flex-1 text-xs md:text-sm leading-relaxed text-foreground-600">
              <strong className="font-semibold text-foreground-900">Trading gold carries real risk.</strong>{' '}
              GoldWarden manages risk by fixed rules, but it cannot remove it — a losing run is always
              possible, and leveraged positions can move against you quickly. Only trade money you can
              afford to lose, and remember that past results never guarantee what comes next.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}